import { useLazyQuery, useQuery } from "@apollo/client";
import { GIVEN_CANS } from "../given-cans.queries";
import { GivenCansQuery, GivenCansQueryVariables } from "../../../__generated__/GivenCansQuery";

export const useGivenCans = (id: number) => {
  return useQuery<GivenCansQuery, GivenCansQueryVariables>(GIVEN_CANS, { variables: { id } });
};

export const useLazyGivenCans = () => {
  return useLazyQuery<GivenCansQuery, GivenCansQueryVariables>(GIVEN_CANS);
};
